import { Input } from '@avanta/shared/components/ui/Input';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ContractSelects } from 'pages/AppointmentsReserve/components/ui/ContractSelects';
import { RecordFields } from 'pages/AppointmentsReserve/components/ui/RecordFields';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/constants';
import { useGetContractOptions } from 'pages/AppointmentsReserve/hooks/useGetContractOptions';
import { type AppointmentsReserveFormData } from 'pages/AppointmentsReserve/types';

export const AdministrativeFields = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { control, setValue } = useFormContext<AppointmentsReserveFormData>();
  const contractAuthorization = useWatch({
    control,
    name: AppointmentsReservePayload.contractAuthorization,
  });
  const { contractOptions, rateOptions, recordFields } = useGetContractOptions();
  const requiredRecordFields = recordFields.filter(recordField => recordField.required);

  const handleContractAuthorizationChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(AppointmentsReservePayload.contractAuthorization, event.target.value);
  };

  return (
    <div className="grid grid-cols-2 gap-6">
      <ContractSelects
        contractOptions={contractOptions}
        rateOptions={rateOptions}
        readOnlyContract
        readOnlyRate
      />
      <RecordFields control={control} recordFields={requiredRecordFields} readOnly />
      <Input
        label={t('AppointmentsReserve.Steps.confirmation.contractAuthorization.label')}
        placeholder={t('AppointmentsReserve.Steps.confirmation.contractAuthorization.placeholder')}
        required={false}
        value={contractAuthorization ?? ''}
        onChange={handleContractAuthorizationChange}
      />
    </div>
  );
};
